// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ksOrderTable .el-table__body-wrapper {\n  padding-bottom: 62px;\n}\n.ksOrderTable.ksTableHeightStyle {\n  min-height: 500px;\n}\n", ""]);
// Exports
module.exports = exports;
